import { render, staticRenderFns } from "./TheHeaderLanguage.vue?vue&type=template&id=c966949a&"
import script from "./TheHeaderLanguage.vue?vue&type=script&lang=js&"
export * from "./TheHeaderLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports